import { getRequestHeaders } from "h3";
import { getDefaultExperiments, getExperimentsFromHeaders } from "../utils.js";
const REQUEST_EXPERIMENTS_CONTEXT_KEY = "$experiments";
export function getRequestExperiments(event) {
  const cachedExperiments = event.context[REQUEST_EXPERIMENTS_CONTEXT_KEY];
  if (cachedExperiments) return cachedExperiments;
  const experiments = Object.freeze({
    ...getDefaultExperiments(),
    ...getExperimentsFromHeaders(getRequestHeaders(event))
  });
  event.context[REQUEST_EXPERIMENTS_CONTEXT_KEY] = experiments;
  return experiments;
}
